// Shared state and helpers for the phone layout (docs/phone-plan.md).
// Copied from hutchies/imperium src/imperium/ui/phone/phone.js and adapted:
// STCC cards are found by uniqueID, and a prompt offers cards as
// $ui.waiting[0].cards. Nothing here changes how a turn resolves.
import { writable } from 'svelte/store';
import { getCard } from '../game.js';

// The player whose tableau is on screen: null for your own.
export const view = writable(null);

// The card in focus (Inspector): { id, from, manual } where from is the rect
// of the card tapped (zoom.js) and manual whether its manual actions show (a
// long press, or ⋯).
export const inspected = writable(null);

export const CARD_RATIO = 22 / 15.75;

// A card by its uniqueID, or null if it has gone.
export function cardOf(id){
    try { return getCard(id); } catch { return null; }
}

// What a card has tucked under it: beamed cards, as on the table.
export const tuckedUnder = c => c?.beamed ?? [];

// uniqueIDs of the cards the waiting prompt offers.
export function offeredIds(ui){
    let w = ui?.waiting?.[0];
    if(!ui?.choosingCards || !w?.cards) return [];
    return w.cards.filter(c => c).map(c => c.uniqueID);
}
